import { DataSourceIcon } from '@/lib';
import { DataSource } from '@/models/dataSource';
import { FC } from 'react';

export interface IUsedDataSourceItem {
  dataSource: DataSource;
}

export const UsedDataSourceItem: FC<IUsedDataSourceItem> = ({ dataSource }) => {
  return (
    <div className='flex gap-2 p-2'>
      <DataSourceIcon type={dataSource.type.id} className='h-5' />
      <span className='text-base capitalize text-tertiary-600'>{dataSource.name}</span>
    </div>
  );
};
